//# sourceMappingURL=data_point.mjs.map
/// <reference types="./data_point.d.mts" />
import * as $json from "../../gleam_json/gleam/json.mjs";
import * as $decode from "../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $float from "../../gleam_stdlib/gleam/float.mjs";
import * as $list from "../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../gleam_stdlib/gleam/option.mjs";
import * as $decrypt from "../decrypt.mjs";
import { toList, CustomType as $CustomType } from "../gleam.mjs";

export class Metadata extends $CustomType {
  constructor(as_html, summary, labels, breadcrumbs, page_title) {
    super();
    this.as_html = as_html;
    this.summary = summary;
    this.labels = labels;
    this.breadcrumbs = breadcrumbs;
    this.page_title = page_title;
  }
}
export const Metadata$Metadata = (as_html, summary, labels, breadcrumbs, page_title) =>
  new Metadata(as_html, summary, labels, breadcrumbs, page_title);
export const Metadata$isMetadata = (value) => value instanceof Metadata;
export const Metadata$Metadata$as_html = (value) => value.as_html;
export const Metadata$Metadata$0 = (value) => value.as_html;
export const Metadata$Metadata$summary = (value) => value.summary;
export const Metadata$Metadata$1 = (value) => value.summary;
export const Metadata$Metadata$labels = (value) => value.labels;
export const Metadata$Metadata$2 = (value) => value.labels;
export const Metadata$Metadata$breadcrumbs = (value) => value.breadcrumbs;
export const Metadata$Metadata$3 = (value) => value.breadcrumbs;
export const Metadata$Metadata$page_title = (value) => value.page_title;
export const Metadata$Metadata$4 = (value) => value.page_title;

export class DataPoint extends $CustomType {
  constructor(id, source_id, metadata, display, kind, text, status) {
    super();
    this.id = id;
    this.source_id = source_id;
    this.metadata = metadata;
    this.display = display;
    this.kind = kind;
    this.text = text;
    this.status = status;
  }
}
export const DataPoint$DataPoint = (id, source_id, metadata, display, kind, text, status) =>
  new DataPoint(id, source_id, metadata, display, kind, text, status);
export const DataPoint$isDataPoint = (value) => value instanceof DataPoint;
export const DataPoint$DataPoint$id = (value) => value.id;
export const DataPoint$DataPoint$0 = (value) => value.id;
export const DataPoint$DataPoint$source_id = (value) => value.source_id;
export const DataPoint$DataPoint$1 = (value) => value.source_id;
export const DataPoint$DataPoint$metadata = (value) => value.metadata;
export const DataPoint$DataPoint$2 = (value) => value.metadata;
export const DataPoint$DataPoint$display = (value) => value.display;
export const DataPoint$DataPoint$3 = (value) => value.display;
export const DataPoint$DataPoint$kind = (value) => value.kind;
export const DataPoint$DataPoint$4 = (value) => value.kind;
export const DataPoint$DataPoint$text = (value) => value.text;
export const DataPoint$DataPoint$5 = (value) => value.text;
export const DataPoint$DataPoint$status = (value) => value.status;
export const DataPoint$DataPoint$6 = (value) => value.status;

export class Text extends $CustomType {}
export const Kind$Text = () => new Text();
export const Kind$isText = (value) => value instanceof Text;

export class Qa extends $CustomType {}
export const Kind$Qa = () => new Qa();
export const Kind$isQa = (value) => value instanceof Qa;

export class Valid extends $CustomType {}
export const Status$Valid = () => new Valid();
export const Status$isValid = (value) => value instanceof Valid;

export class Outdated extends $CustomType {}
export const Status$Outdated = () => new Outdated();
export const Status$isOutdated = (value) => value instanceof Outdated;

export class DisplayText extends $CustomType {
  constructor(as_html, page_number) {
    super();
    this.as_html = as_html;
    this.page_number = page_number;
  }
}
export const Display$DisplayText = (as_html, page_number) =>
  new DisplayText(as_html, page_number);
export const Display$isDisplayText = (value) => value instanceof DisplayText;
export const Display$DisplayText$as_html = (value) => value.as_html;
export const Display$DisplayText$0 = (value) => value.as_html;
export const Display$DisplayText$page_number = (value) => value.page_number;
export const Display$DisplayText$1 = (value) => value.page_number;

export class DisplayQa extends $CustomType {
  constructor(as_html, question, answer, row_number, sheet_name, header, section, sub_section, context_question, comments) {
    super();
    this.as_html = as_html;
    this.question = question;
    this.answer = answer;
    this.row_number = row_number;
    this.sheet_name = sheet_name;
    this.header = header;
    this.section = section;
    this.sub_section = sub_section;
    this.context_question = context_question;
    this.comments = comments;
  }
}
export const Display$DisplayQa = (as_html, question, answer, row_number, sheet_name, header, section, sub_section, context_question, comments) =>
  new DisplayQa(as_html,
  question,
  answer,
  row_number,
  sheet_name,
  header,
  section,
  sub_section,
  context_question,
  comments);
export const Display$isDisplayQa = (value) => value instanceof DisplayQa;
export const Display$DisplayQa$as_html = (value) => value.as_html;
export const Display$DisplayQa$0 = (value) => value.as_html;
export const Display$DisplayQa$question = (value) => value.question;
export const Display$DisplayQa$1 = (value) => value.question;
export const Display$DisplayQa$answer = (value) => value.answer;
export const Display$DisplayQa$2 = (value) => value.answer;
export const Display$DisplayQa$row_number = (value) => value.row_number;
export const Display$DisplayQa$3 = (value) => value.row_number;
export const Display$DisplayQa$sheet_name = (value) => value.sheet_name;
export const Display$DisplayQa$4 = (value) => value.sheet_name;
export const Display$DisplayQa$header = (value) => value.header;
export const Display$DisplayQa$5 = (value) => value.header;
export const Display$DisplayQa$section = (value) => value.section;
export const Display$DisplayQa$6 = (value) => value.section;
export const Display$DisplayQa$sub_section = (value) => value.sub_section;
export const Display$DisplayQa$7 = (value) => value.sub_section;
export const Display$DisplayQa$context_question = (value) =>
  value.context_question;
export const Display$DisplayQa$8 = (value) => value.context_question;
export const Display$DisplayQa$comments = (value) => value.comments;
export const Display$DisplayQa$9 = (value) => value.comments;

export const Display$as_html = (value) => value.as_html;

function status_decoder() {
  return $decode.then$(
    $decode.string,
    (status) => {
      if (status === "valid") {
        return $decode.success(new Valid());
      } else if (status === "outdated") {
        return $decode.success(new Outdated());
      } else {
        return $decode.failure(new Valid(), "Status");
      }
    },
  );
}

function kind_decoder() {
  return $decode.then$(
    $decode.string,
    (kind) => {
      let expected = "text | qa";
      if (kind === "text") {
        return $decode.success(new Text());
      } else if (kind === "qa") {
        return $decode.success(new Qa());
      } else {
        return $decode.failure(new Text(), expected);
      }
    },
  );
}

function display_qa_decoder() {
  return $decode.field(
    "as_html",
    $decode.optional($decode.string),
    (as_html) => {
      return $decode.field(
        "question",
        $decode.string,
        (question) => {
          return $decode.field(
            "answer",
            $decode.string,
            (answer) => {
              return $decode.field(
                "row_number",
                $decode.int,
                (row_number) => {
                  return $decode.field(
                    "sheet_name",
                    $decode.string,
                    (sheet_name) => {
                      return $decrypt.optional_field(
                        "header",
                        $decode.string,
                        (header) => {
                          return $decrypt.optional_field(
                            "section",
                            $decode.string,
                            (section) => {
                              return $decrypt.optional_field(
                                "sub_section",
                                $decode.string,
                                (sub_section) => {
                                  return $decrypt.optional_field(
                                    "context_question",
                                    $decode.string,
                                    (context_question) => {
                                      return $decrypt.optional_field(
                                        "comments",
                                        $decode.string,
                                        (comments) => {
                                          let _pipe = new DisplayQa(
                                            as_html,
                                            question,
                                            answer,
                                            row_number,
                                            sheet_name,
                                            header,
                                            section,
                                            sub_section,
                                            context_question,
                                            comments,
                                          );
                                          return $decode.success(_pipe);
                                        },
                                      );
                                    },
                                  );
                                },
                              );
                            },
                          );
                        },
                      );
                    },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

function display_text_decoder() {
  return $decode.field(
    "as_html",
    $decode.optional($decode.string),
    (as_html) => {
      return $decode.field(
        "page_number",
        $decode.int,
        (page_number) => {
          return $decode.success(new DisplayText(as_html, page_number));
        },
      );
    },
  );
}

function display_decoder() {
  let text = display_text_decoder();
  let qa = display_qa_decoder();
  return $decode.one_of(text, toList([qa]));
}

function metadata_decoder() {
  return $decrypt.optional_field(
    "as_html",
    $decode.string,
    (as_html) => {
      return $decrypt.optional_field(
        "summary",
        $decode.string,
        (summary) => {
          return $decode.optional_field(
            "breadcrumbs",
            toList([]),
            $decode.list($decode.string),
            (breadcrumbs) => {
              return $decrypt.optional_field(
                "page_title",
                $decode.string,
                (page_title) => {
                  return $decrypt.optional_field(
                    "labels",
                    $decode.list($decode.string),
                    (labels) => {
                      let labels$1 = $option.unwrap(labels, toList([]));
                      return $decode.success(
                        new Metadata(
                          as_html,
                          summary,
                          labels$1,
                          breadcrumbs,
                          page_title,
                        ),
                      );
                    },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

export function decoder() {
  return $decode.field(
    "id",
    $decrypt.uuid(),
    (id) => {
      return $decode.field(
        "source_id",
        $decrypt.uuid(),
        (source_id) => {
          return $decode.field(
            "metadata",
            $decrypt.json(metadata_decoder()),
            (metadata) => {
              return $decode.field(
                "display",
                $decrypt.json(display_decoder()),
                (display) => {
                  return $decode.field(
                    "kind",
                    kind_decoder(),
                    (kind) => {
                      return $decode.field(
                        "text",
                        $decode.string,
                        (text) => {
                          return $decode.field(
                            "status",
                            status_decoder(),
                            (status) => {
                              return $decode.success(
                                new DataPoint(
                                  id,
                                  source_id,
                                  metadata,
                                  display,
                                  kind,
                                  text,
                                  status,
                                ),
                              );
                            },
                          );
                        },
                      );
                    },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

export function id_decoder() {
  return $decode.field(
    "data_point_id",
    $decode.optional($decode.string),
    (a) => {
      return $decode.field(
        "score",
        $decode.optional($decrypt.float()),
        (b) => {
          if (a instanceof $option.Some && b instanceof $option.Some) {
            let a$1 = a[0];
            let b$1 = b[0];
            return $decode.success(new $option.Some([a$1, b$1]));
          } else {
            return $decode.success(new $option.None());
          }
        },
      );
    },
  );
}

export function ids_decoder() {
  let _pipe = $decode.list(id_decoder());
  let _pipe$1 = $decode.map(_pipe, $option.values);
  return $decode.map(
    _pipe$1,
    (_capture) => {
      return $list.sort(
        _capture,
        (a, b) => { return $float.compare(b[1], a[1]); },
      );
    },
  );
}

export function id_encode(value) {
  let id = value[0];
  let score = value[1];
  return $json.object(
    toList([["data_point_id", $json.string(id)], ["score", $json.float(score)]]),
  );
}

export function ids_encode(value) {
  return $json.array(value, id_encode);
}

function encode_status(status) {
  if (status instanceof Valid) {
    return $json.string("valid");
  } else {
    return $json.string("outdated");
  }
}

function encode_kind(kind) {
  if (kind instanceof Text) {
    return $json.string("text");
  } else {
    return $json.string("qa");
  }
}

function encode_display(display) {
  if (display instanceof DisplayText) {
    let as_html = display.as_html;
    let page_number = display.page_number;
    return $json.object(
      toList([
        ["as_html", $json.nullable(as_html, $json.string)],
        ["page_number", $json.int(page_number)],
      ]),
    );
  } else {
    let as_html = display.as_html;
    let question = display.question;
    let answer = display.answer;
    let row_number = display.row_number;
    let sheet_name = display.sheet_name;
    let header = display.header;
    let section = display.section;
    let sub_section = display.sub_section;
    let context_question = display.context_question;
    let comments = display.comments;
    return $json.object(
      toList([
        ["as_html", $json.nullable(as_html, $json.string)],
        ["question", $json.string(question)],
        ["answer", $json.string(answer)],
        ["row_number", $json.int(row_number)],
        ["sheet_name", $json.string(sheet_name)],
        ["header", $json.nullable(header, $json.string)],
        ["section", $json.nullable(section, $json.string)],
        ["sub_section", $json.nullable(sub_section, $json.string)],
        ["context_question", $json.nullable(context_question, $json.string)],
        ["comments", $json.nullable(comments, $json.string)],
      ]),
    );
  }
}

function encode_metadata(metadata) {
  return $json.object(
    toList([
      ["as_html", $json.nullable(metadata.as_html, $json.string)],
      ["summary", $json.nullable(metadata.summary, $json.string)],
      ["breadcrumbs", $json.array(metadata.breadcrumbs, $json.string)],
      ["labels", $json.array(metadata.labels, $json.string)],
      ["page_title", $json.nullable(metadata.page_title, $json.string)],
    ]),
  );
}

export function encode(data_point) {
  return $json.object(
    toList([
      ["id", $json.string(data_point.id)],
      ["source_id", $json.string(data_point.source_id)],
      ["metadata", encode_metadata(data_point.metadata)],
      ["display", encode_display(data_point.display)],
      ["kind", encode_kind(data_point.kind)],
      ["text", $json.string(data_point.text)],
      ["status", encode_status(data_point.status)],
    ]),
  );
}

export function kind_to_string(kind) {
  if (kind instanceof Text) {
    return "Text";
  } else {
    return "QA";
  }
}

export function status_to_string(status) {
  if (status instanceof Valid) {
    return "Valid";
  } else {
    return "Outdated";
  }
}
